import React, { Component } from 'react';
//i18n
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardTitle,
  Container,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import Loader from '../../components/Common/Loader';
import WsPositionsList from '../../components/Lists/WsPositionsList';
import { position_status } from '../../constants/WsPositions_fields';
//Import actions redux
import {
  checkWsPositions,
  lockWSPosition,
  unlockWSPosition,
  checkWorkWSPosition,
  getQueuePositions,
  addQueuePosition,
  getMapPositions,
  updateFacesValues,
  getRotatePositions,
  addRotationPosition,
} from '../../store/actions';

class WSPositions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      ws_positions_list: null,
      ws_positions_raw: null,
      modal_standard: false,
      modal_standard_faces: false,
      faces_values: {
        E: '',
        N: '',
        O: '',
        S: '',
      },
      ws_pos: null,
      queue_init: null,
      queue_end: null,
      confirmation_point: null,
      queue_positions: null,
      map_positions: null,
      modal_standard_rotate: false,
      rotation_point: null,
      rotate_point_list: null,
    };
  }

  componentDidMount() {
    this.props.checkWsPositions(this.state.user);
    this.props.getQueuePositions(this.state.user);
    this.props.getMapPositions(this.state.user);
    this.props.getRotatePositions(this.state.user);
  }

  componentDidUpdate(prevProps) {
    // P01021-142: las 4 cargas (posiciones + las 3 listas de alias) son independientes y se
    // relanzan TODAS desde cero en cada `history.go()` (recarga completa del navegador, el
    // mecanismo de refresco que usan addQueuePosition/addRotationPosition/updateFacesValues
    // tras guardar) — no hay ningún orden garantizado entre ellas. En vez de construir la
    // tabla en cuanto llegan las posiciones (arriesgándose a resolver el alias contra una
    // lista todavía vacía y dejar el código crudo fijado para siempre), se guarda cada pieza
    // por separado y solo se construye la tabla una vez están las 4 disponibles — determinista,
    // sin depender de qué petición de red gane la carrera.
    if (this.props.loadingCheckWsPositions === false && prevProps.loadingCheckWsPositions === true) {
      if (this.props.ws_positions) {
        this.setState({ ws_positions_raw: this.props.ws_positions });
      }
    }
    if (this.props.loadingGetQueuePositions === false && prevProps.loadingGetQueuePositions === true) {
      if (this.props.queue_positions) {
        this.setState({ queue_positions: this.props.queue_positions });
      }
    }
    if (this.props.loadingGetMapPositions === false && prevProps.loadingGetMapPositions === true) {
      if (this.props.map_positions) {
        this.setState({ map_positions: this.props.map_positions });
      }
    }
    if (this.props.loadingGetRotatePositions === false && prevProps.loadingGetRotatePositions === true) {
      if (this.props.rotate_positions) {
        this.setState({ rotate_point_list: this.props.rotate_positions });
      }
    }
    this.maybeBuildTable();
  }

  maybeBuildTable() {
    const { ws_positions_raw, rotate_point_list, queue_positions, map_positions, ws_positions_list } = this.state;
    if (ws_positions_raw && rotate_point_list && queue_positions && map_positions && !ws_positions_list) {
      this.prepareData(ws_positions_raw);
    }
  }

  lock(wspos) {
    this.props.lockWSPosition(wspos, this.state.user.token, this.props.history);
  }
  unlock(wspos) {
    this.props.unlockWSPosition(wspos, this.state.user.token, this.props.history);
  }

  checkForWork(wspos, value) {
    this.props.checkWorkWSPosition(wspos, value, this.state.user.token, this.props.history);
  }

  handleEdit(position) {
    this.setState({
      modal_standard: true,
      ws_pos: position.ws_pos,
      queue_init: position.queueInitRaw,
      queue_end: position.queueEndRaw,
      confirmation_point: position.confirmationPointRaw,
    });
  }

  handleEditFace(position) {
    const faces = JSON.parse(position.faces_values || '{}');
    this.setState({
      modal_standard_faces: true,
      ws_pos: position.ws_pos,
      faces_values: {
        E: faces.E || '',
        N: faces.N || '',
        O: faces.O || '',
        S: faces.S || '',
      },
    });
  }

  handleEditRotate(position) {
    this.setState({
      modal_standard_rotate: true,
      ws_pos: position.ws_pos,
      rotation_point: position.rotatePointRaw,
    });
  }

  handleRotatePointChange(value) {
    this.setState({ rotation_point: value });
  }

  handleSaveRotateChanges = () => {
    const { ws_pos, rotation_point } = this.state;
    const empty = this.props.t('NotAssigned');

    let rotation_point_check = rotation_point === empty ? null : rotation_point;

    this.props.addRotationPosition(ws_pos, rotation_point_check, this.state.user.token, this.props.history);

    this.setState({ modal_standard_rotate: false });
  };

  handleFaceValueChange = (key, value) => {
    this.setState((prevState) => ({
      faces_values: {
        ...prevState.faces_values,
        [key]: value,
      },
    }));
  };

  handleConfirmationPointChange(value) {
    this.setState({ confirmation_point: value });
  }

  handleQueueInitChange(value) {
    this.setState({ queue_init: value });
  }

  handleQueueEndChange(value) {
    console.log({ value });
    this.setState({ queue_end: value });
  }

  handleSaveChanges = () => {
    const { ws_pos, queue_init, queue_end, confirmation_point } = this.state;
    const empty = this.props.t('NotAssigned');

    let queue_init_check = queue_init === empty ? null : queue_init;
    let queue_end_check = queue_end === empty ? null : queue_end;
    let confirmation_point_check = confirmation_point === empty ? null : confirmation_point;

    // Llama a la acción de Redux para guardar los cambios
    this.props.addQueuePosition(
      ws_pos,
      queue_init_check,
      queue_end_check,
      confirmation_point_check,
      this.state.user.token,
      this.props.history,
    );

    // Cierra el modal después de guardar los cambios
    this.setState({ modal_standard: false });
  };

  handleSaveFaceChanges = () => {
    const { ws_pos, faces_values } = this.state;

    // Convierte los valores de las caras a JSON
    const facesJson = JSON.stringify(faces_values);

    console.log('Saving faces JSON:', facesJson);

    this.props.updateFacesValues(ws_pos, facesJson, this.state.user.token, this.props.history);

    // Cierra el modal
    this.setState({ modal_standard_faces: false });
  };

  prepareData(ws_positions) {
    let ws_set = [this.props.t('No assignada')];
    let ws_positions_list = [{ ws_name: this.props.t('No assignada'), positions: [] }];
    ws_positions.forEach((position) => {
      position['status_name'] = (
        <Badge
          color={position_status[position.ws_pos_status].color}
          className={'badge-soft-' + position_status[position.ws_pos_status].color + ' font-size-14'}
          pill
        >
          {position_status[position.ws_pos_status].name}
        </Badge>
      );
      position['disponible'] =
        parseInt(position.disponible) === 1 ? (
          <Button
            onClick={(event) => this.lock(position.ws_pos)}
            className="btn btn-danger waves-effect waves-light buttonStatus"
          >
            <i className="bx bx-block font-size-16 align-middle mr-2" />
            {this.props.t('Bloquear')}
          </Button>
        ) : (
          <Button
            onClick={(event) => this.unlock(position.ws_pos)}
            className="btn btn-success waves-effect waves-light buttonStatus"
          >
            <i className="bx bx-block font-size-16 align-middle mr-2" />
            {this.props.t('Desbloquear')}
          </Button>
        );
      position['checkForWork'] =
        parseInt(position.checkForWork) === 1 ? (
          <Button
            onClick={(event) => this.checkForWork(position.ws_pos, 0)}
            className="btn btn-danger waves-effect waves-light buttonStatus"
          >
            <i className="bx bx-block font-size-16 align-middle mr-2" />
            {this.props.t('Forzado por SGA')}
          </Button>
        ) : (
          <Button
            onClick={(event) => this.checkForWork(position.ws_pos, 1)}
            className="btn btn-success waves-effect waves-light buttonStatus"
          >
            <i className="bx bx-check font-size-16 align-middle mr-2" />
            {this.props.t('Automático al llegar rack')}
          </Button>
        );
      // Mismo patrón que rotatePoint (P01021-142): se guarda el valor crudo aparte
      // (confirmationPointRaw/queueInitRaw/queueEndRaw) para que handleEdit pueda preseleccionar
      // la opción correcta en los <select> (indexados por id), y se muestra el alias legible
      // si existe (map_positions/queue_positions, buscado por id) vía buildAliasBadge.
      position['confirmationPointRaw'] = position.confirmation_point;
      position['confirmation_point'] = this.buildAliasBadge(position.confirmation_point, this.state.map_positions);
      position['queueInitRaw'] = position.queue_init;
      position['queue_init'] = this.buildAliasBadge(position.queue_init, this.state.queue_positions);
      position['queueEndRaw'] = position.queue_end;
      position['queue_end'] = this.buildAliasBadge(position.queue_end, this.state.queue_positions);
      position['editButton'] = (
        <Button
          onClick={() => this.handleEdit(position)} // Reemplaza handleEdit con la función que necesitas
          className="btn btn-primary waves-effect waves-light buttonStatus"
        >
          <i className="bx bx-edit font-size-16 align-middle mr-2" />
          {this.props.t('Editar Colas')}
        </Button>
      );
      // P01021-142: punto de rotación por posición (antes era único por estación). Se guarda
      // (y se manda a RCS) el código crudo (rcs_position_id), pero se muestra el alias
      // (rcs_position_name) si existe — igual que en el desplegable de "Editar Rotación".
      // El valor crudo se conserva aparte (rotatePointRaw) para que handleEditRotate pueda
      // preseleccionar la opción correcta en el <select>, que sigue indexado por id.
      const rotatePointRaw = position.rotatePoint;
      position['rotatePointRaw'] = rotatePointRaw;
      const rotatePointOption = this.state.rotate_point_list?.find((p) => p.id === rotatePointRaw);
      position['rotatePoint'] =
        rotatePointRaw === null ? (
          <Badge className={'badge-soft-danger font-size-14'} pill>
            {this.props.t('NotAssigned')}
          </Badge>
        ) : (
          <Badge className={'badge-soft-success font-size-14'} pill>
            {rotatePointOption ? rotatePointOption.name : rotatePointRaw}
          </Badge>
        );
      position['editRotateButton'] = (
        <Button
          onClick={() => this.handleEditRotate(position)}
          className="btn btn-primary waves-effect waves-light buttonStatus"
        >
          <i className="bx bx-edit font-size-16 align-middle mr-2" />
          {this.props.t('Editar Rotación')}
        </Button>
      );
      position['editFaceButton'] = (
        <Button
          onClick={() => this.handleEditFace(position)} // Reemplaza handleEditFace con la función que necesitas
          className="btn btn-primary waves-effect waves-light buttonStatus"
        >
          <i className="bx bx-edit font-size-16 align-middle mr-2" />
          {this.props.t('Editar Caras')}
        </Button>
      );

      if (position.ws_id) {
        let index = ws_set.indexOf(position.ws_id);
        if (index !== -1) {
          ws_positions_list[index].positions.push(position);
        } else {
          ws_positions_list.push({
            ws_name: position.ws_id,
            positions: [position],
          });
          ws_set.push(position.ws_id);
        }
      } else {
        ws_positions_list[0].positions.push(position);
      }
    });
    if (ws_positions_list[0].positions.length === 0) {
      ws_positions_list.shift();
    }
    this.setState({ ws_positions_list: ws_positions_list });
  }

  // P01021-142: resuelve el alias legible (rcs_position_name) de un valor crudo
  // (rcs_position_id) contra la lista correspondiente (rotate_point_list/queue_positions/
  // map_positions), con fallback al propio crudo si no hay coincidencia. Usado por
  // prepareData — que ahora solo se ejecuta una vez las 4 fuentes de datos están listas
  // (ver maybeBuildTable), así que esta resolución siempre tiene la lista completa disponible,
  // sin necesitar ningún parche posterior.
  buildAliasBadge(raw, list) {
    if (raw === null) {
      return (
        <Badge className={'badge-soft-danger font-size-14'} pill>
          {this.props.t('NotAssigned')}
        </Badge>
      );
    }
    const option = list?.find((p) => p.id === raw);
    return (
      <Badge className={'badge-soft-success font-size-14'} pill>
        {option ? option.name : raw}
      </Badge>
    );
  }

  refresh(event) {
    event.preventDefault();
    this.setState({ ws_positions_list: null, ws_positions_raw: null });
    this.props.checkWsPositions(this.state.user);
  }

  newWorkstation(event) {
    event.preventDefault();
    this.props.history.push({
      pathname: '/createworkstation',
      query: { origin_path: '/workstations-positions' },
    });
  }

  render() {
    if (
      !this.state.ws_positions_list ||
      !this.state.queue_positions ||
      !this.state.map_positions ||
      !this.state.rotate_point_list
    ) {
      return (
        <React.Fragment>
          <div className="loaderCenter">
            <Loader></Loader>
          </div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <div className="user-management">
          <Container fluid>
            <Button
              onClick={(event) => this.refresh(event)}
              color="primary"
              className="btn btn-primary buttonStatus usersButtons"
            >
              {' '}
              <i size="lg" className="mdi  mdi-refresh"></i>
            </Button>
            {this.state.user.role_id < 3 && (
              <Button
                onClick={(event) => this.newWorkstation(event)}
                className="btn btn-primary waves-effect waves-light buttonStatus usersButtons"
              >
                <Link to="createworkstation">{this.props.t('Crear nueva estación de trabajo')}</Link>
              </Button>
            )}
            {this.state.ws_positions_list.map((ws, index) => {
              return (
                <Card key={index}>
                  <CardBody>
                    <CardTitle>{ws.ws_name}</CardTitle>
                    <WsPositionsList positionsList={ws.positions}></WsPositionsList>
                  </CardBody>
                </Card>
              );
            })}
          </Container>
        </div>
        <>
          <Modal isOpen={this.state.modal_standard}>
            <ModalHeader>
              {this.props.t('EditQueues')} {this.state.ws_pos}
            </ModalHeader>
            <ModalBody>
              <FormGroup>
                <Label htmlFor="outsidePointSelect">{this.props.t('OutsidePoint')}</Label>
                <Input
                  type="select"
                  name="outsidePointSelect"
                  id="outsidePointSelect"
                  defaultValue={this.state.confirmation_point}
                  onChange={(e) => this.handleConfirmationPointChange(e.target.value)}
                >
                  {this.state.map_positions.map((point, key) => (
                    <option key={key} value={point.id}>
                      {point.name}
                    </option>
                  ))}
                  <option key="empty" value={undefined}>
                    {this.props.t('NotAssigned')}
                  </option>
                </Input>
              </FormGroup>
              <FormGroup>
                <Label htmlFor="queueInitSelect">{this.props.t('QueueInit')}</Label>
                <Input
                  type="select"
                  name="queueInitSelect"
                  id="queueInitSelect"
                  defaultValue={this.state.queue_init}
                  onChange={(e) => this.handleQueueInitChange(e.target.value)}
                >
                  {this.state.queue_positions.map((point, key) => (
                    <option key={key} value={point.id}>
                      {point.name}
                    </option>
                  ))}
                  <option key="empty" value={undefined}>
                    {this.props.t('NotAssigned')}
                  </option>
                </Input>
              </FormGroup>

              <FormGroup>
                <Label htmlFor="queueEndSelect">{this.props.t('QueueEnd')}</Label>
                <Input
                  type="select"
                  name="queueEndSelect"
                  id="queueEndSelect"
                  value={this.state.queue_end}
                  onChange={(e) => this.handleQueueEndChange(e.target.value)}
                >
                  {this.state.queue_positions.map((point, key) => (
                    <option key={key} value={point.id}>
                      {point.name}
                    </option>
                  ))}
                  <option key="empty" value={undefined}>
                    {this.props.t('NotAssigned')}
                  </option>
                </Input>
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <button
                type="button"
                onClick={() => this.setState({ modal_standard: false })}
                className="btn btn-danger waves-effect"
                data-dismiss="modal"
              >
                {this.props.t('Cancel')}
              </button>
              <button
                type="button"
                className="btn btn-success waves-effect waves-light"
                onClick={this.handleSaveChanges}
              >
                {this.props.t('Save')}
              </button>
            </ModalFooter>
          </Modal>
        </>
        <>
          <Modal isOpen={this.state.modal_standard_faces}>
            <ModalHeader>
              {this.props.t('EditFaces')} {this.state.ws_pos}
            </ModalHeader>
            <ModalBody>
              {['E', 'N', 'O', 'S'].map((direction) => (
                <FormGroup key={direction}>
                  <Label htmlFor={`${direction}Cara`}>{this.props.t(`Cara ${direction}`)}</Label>
                  <Input
                    type="text"
                    name={`${direction}Cara`}
                    id={`${direction}Cara`}
                    value={this.state.faces_values[direction]}
                    onChange={(e) => this.handleFaceValueChange(direction, e.target.value)}
                  />
                </FormGroup>
              ))}
            </ModalBody>
            <ModalFooter>
              <button
                type="button"
                onClick={() => this.setState({ modal_standard_faces: false })}
                className="btn btn-danger waves-effect"
                data-dismiss="modal"
              >
                {this.props.t('Cancel')}
              </button>
              <button
                type="button"
                className="btn btn-success waves-effect waves-light"
                onClick={this.handleSaveFaceChanges}
              >
                {this.props.t('Save')}
              </button>
            </ModalFooter>
          </Modal>
        </>
        <>
          <Modal isOpen={this.state.modal_standard_rotate}>
            <ModalHeader>
              {this.props.t('EditRotationPoint')} {this.state.ws_pos}
            </ModalHeader>
            <ModalBody>
              <FormGroup>
                <Label htmlFor="rotatePointSelect">{this.props.t('RotatePoint')}</Label>
                <Input
                  type="select"
                  name="rotatePointSelect"
                  id="rotatePointSelect"
                  defaultValue={this.state.rotation_point}
                  onChange={(e) => this.handleRotatePointChange(e.target.value)}
                >
                  {this.state.rotate_point_list.map((point, key) => (
                    <option key={key} value={point.id}>
                      {point.name}
                    </option>
                  ))}
                  <option key="empty" value={undefined}>
                    {this.props.t('NotAssigned')}
                  </option>
                </Input>
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <button
                type="button"
                onClick={() => this.setState({ modal_standard_rotate: false })}
                className="btn btn-danger waves-effect"
                data-dismiss="modal"
              >
                {this.props.t('Cancel')}
              </button>
              <button
                type="button"
                className="btn btn-success waves-effect waves-light"
                onClick={this.handleSaveRotateChanges}
              >
                {this.props.t('Save')}
              </button>
            </ModalFooter>
          </Modal>
        </>
      </React.Fragment>
    );
  }
}

const mapStateProps = (state) => {
  const { errorCheckWsPositions, loadingCheckWsPositions, ws_positions } = state.CheckWSPositions;
  const { lockWSPositionError, messageLockWSPosition, loadingLockWSPosition } = state.LockWSPosition;
  const { errorGetQueuePositions, loadingGetQueuePositions, queue_positions } = state.getQueuePositions;
  const { errorGetMapPositions, loadingGetMapPositions, map_positions } = state.getMapPositions;
  const { errorGetRotatePositions, loadingGetRotatePositions, rotate_positions } = state.getRotatePositions;
  return {
    errorCheckWsPositions,
    loadingCheckWsPositions,
    ws_positions,
    lockWSPositionError,
    messageLockWSPosition,
    loadingLockWSPosition,
    errorGetQueuePositions,
    loadingGetQueuePositions,
    queue_positions,
    errorGetMapPositions,
    loadingGetMapPositions,
    map_positions,
    errorGetRotatePositions,
    loadingGetRotatePositions,
    rotate_positions,
  };
};

export default withRouter(
  connect(mapStateProps, {
    checkWsPositions,
    lockWSPosition,
    unlockWSPosition,
    checkWorkWSPosition,
    getQueuePositions,
    addQueuePosition,
    getMapPositions,
    updateFacesValues,
    getRotatePositions,
    addRotationPosition,
  })(withNamespaces()(WSPositions)),
);
